<template>
	<div class="gb-month-header">
		<div class="gb-cell gb-month-caption white--text primary" color="primary" tile
			:style="styleMonth"
		>
			<div v-show="!display">{{ month.ym }}</div>
		</div>
		<template v-if="isCalendarTickTerm">
			<div>
				<GBDay v-for="day in month.days" :key="day.code" :day="day" :width="$store.getters.unitWidth"/>
			</div>
			<div>
				<GBTerm v-for="term in month.terms" :key="term.code" :term="term" />
			</div>
			<div v-if="showFreePerson">
				<GBDayFreePerson
					v-for="term in month.terms"
					v-bind:key="term.code"
					v-bind:schedule="term.schedule"
					v-bind:code="term.code"
					v-on:show-free-persons="onClickShowFreePersons"
				/>
			</div>
		</template>
		<template v-else-if="isCalendarTickDay">
			<div>
				<GBDay v-for="day in month.days" v-bind:key="day.code" v-bind:day="day" v-bind:width="$store.getters.unitWidth" />
			</div>
			<div>
				<GBDayWeekDay v-for="day in month.days" v-bind:key="day.code" v-bind:day="day" />
			</div>
			<div v-if="showFreePerson">
				<GBDayFreePerson
					v-for="day in month.days"
					v-bind:key="day.code"
					v-bind:schedule="day.schedule"
					v-bind:code="day.code"
					v-on:show-free-persons="onClickShowFreePersons"
				/>
			</div>
		</template>
		<template v-else-if="isCalendarTickWeek">
			<div>
				<GBWeekFirstDay v-for="week in month.weeks" :key="week.code" :week="week" />
			</div>
		</template>
	</div>
</template>
<script>
import GBDayFreePerson from './GBDayFreePerson';
import GBDayWeekDay from './GBDayWeekDay';
import GBTerm from './GBTerm';
import GBDay from './GBDay';
import GBWeekFirstDay from './GBWeekFirstDay';
import { CALENDAR_TICK, PERMISSION } from '../data/Const';

export default {
	name: 'GBMonth',
	props: ["month", "freePersons"],
	components: {
		GBDayFreePerson,
		GBDayWeekDay,
		GBTerm,
		GBDay,
		GBWeekFirstDay,
	},
	methods: {
		onClickShowFreePersons: function(e) {
			this.$emit("show-free-persons", e);
		},
	},
	computed: {
		isCalendarTickTerm() {
			return this.$store.getters.calendarTick === CALENDAR_TICK.TERM;
		},
		isCalendarTickDay() {
			return this.$store.getters.calendarTick === CALENDAR_TICK.DAY;
		},
		isCalendarTickWeek() {
			return this.$store.getters.calendarTick === CALENDAR_TICK.WEEK;
		},
		styleMonth() {
			let max_width = 42 * this.month.days.length;
			let height = 24;
			if (this.isCalendarTickTerm)
				max_width = max_width * 2;
			if (!this.showFreePerson)
				height = 45;
			if (this.isCalendarTickWeek)
				height = 66;

			return {
				'height': height + 'px',
				'line-height': height + 'px', 
				'max-width': max_width + 'px',
			};
		},
		display() {
			return (this.isCalendarTickWeek && this.month.weeks.length === 1) || (this.isCalendarTickDay && this.month.days.length === 1);
		},
		showFreePerson: function() {
			return (this.$store.getters.hasPermission(PERMISSION.TYPE.ADMIN | PERMISSION.TYPE.VIEWER) && this.$store.getters.isShowFreePerson);
		},
	},
}
</script>
<style>
	.gb-month-header {
		display: inline-block;
		text-align: center;
		border-top: 1px solid #FFF;
	}

	.gb-month-caption {
		position: relative;
		border-radius: 0;
	}
	
	.gb-cell{
		outline:1px solid #DFDFDF;
		/* height:24px; */
		transition: line-height .3s;
	}
</style>

